'use client'

import { BlankFillingQuestion } from '@entities/lesson'
import { replaceSentenceByAnswer } from '@features/lesson-review'
import { clsx } from 'clsx'

import { Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: BlankFillingQuestion
  userAnswer: string[]
  masterAnswer: string[]
  aiExplanation: string
  masterHighlight: number[]
}

export const WrongBlankFillingToastDescription = ({ question, userAnswer, masterAnswer, aiExplanation }: Props) => {
  const [replacedUserAnswer, replacedMasterAnswer] = [
    replaceSentenceByAnswer(question, userAnswer),
    replaceSentenceByAnswer(question, masterAnswer),
  ]
  return (
    <VStack className="gap-4">
      <VStack className="gap-0.5">
        <Typography size="h6" className="font-medium text-white">
          {replacedUserAnswer.map((part, index, origin) => {
            const isUserAnswerPart = userAnswer.includes(part)
            const isLastIndex = index === origin.length - 1

            return (
              <span key={`userAnswer-${part}`} className={clsx(isUserAnswerPart ? 'text-red-normal' : '')}>
                {`${part}${isLastIndex ? '' : ' '}`}
              </span>
            )
          })}
        </Typography>
        <Typography size="h6" className="font-medium text-white">
          {replacedMasterAnswer.map((part, index, origin) => {
            const isMasterAnswerPart = masterAnswer.includes(part)
            const isLastIndex = index === origin.length - 1

            return (
              <span key={`masterAnswer-${part}`} className={clsx(isMasterAnswerPart ? 'text-blue-normal' : '')}>
                {`${part}${isLastIndex ? '' : ' '}`}
              </span>
            )
          })}
        </Typography>
      </VStack>
      <Typography size="h6" className="font-medium text-gray-400">
        {aiExplanation}
      </Typography>
    </VStack>
  )
}
